export const cookieConsentKey = "nossa-cookie-consent";
export const cookieConsentValues = {
  accepted: "accepted",
  rejected: "rejected",
};

export function getCookieConsent() {
  return window.localStorage.getItem(cookieConsentKey);
}

export function setCookieConsent(value) {
  window.localStorage.setItem(cookieConsentKey, value);
}

export function hasAcceptedAnalyticsCookies() {
  return getCookieConsent() === cookieConsentValues.accepted;
}